import { DotsHorizontalIcon } from "@radix-ui/react-icons";
import { Row } from "@tanstack/react-table";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

import { Button } from "@/components/ui/button/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu/dropdown-menu";
import { Employee } from "./schema";
import { useCheckinModal } from "../checkins/use-checkin-modal";

interface DataTableRowActionsProps<TData> {
  row: Row<TData>;
}

export function DataTableRowActions<TData>({
  row,
}: DataTableRowActionsProps<TData>) {
  const navigate = useNavigate();
  const originData = row.original as Employee & {
    blocked: boolean;
  };

  const [open, setOpen] = useState(false);

  const { onOpenChange, setCheckinId } = useCheckinModal();

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          className="flex h-8 w-8 p-0 data-[state=open]:bg-muted"
        >
          <DotsHorizontalIcon className="h-4 w-4" />
          <span className="sr-only">Open menu</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[160px]">
        <DropdownMenuItem
          onMouseDown={() => {
            setCheckinId(originData?.id);
            onOpenChange(true);
            setOpen(false);
          }}
        >
          Checkins
        </DropdownMenuItem>
        {/* <DropdownMenuItem
          onMouseDown={() => {
            navigate(`/admin/employees/${originData.id}`);
          }}
        >
          Edit
        </DropdownMenuItem> */}
        {/* <DropdownMenuItem
          onMouseDown={() => {
            navigate(
              `/admin/employees/salary/${originData.id}?n=${originData?.name}`
            );
          }}
        >
          Salary
        </DropdownMenuItem> */}
        <DropdownMenuItem
          onMouseDown={() => {
            navigate(
              `/superadmin/employees/activity/${originData.id}?n=${originData?.name}`
            );
          }}
        >
          Activity
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
